__turbopack_context__.v({
  "colors": "Device-module__vi7NAW__colors",
  "deviceImage": "Device-module__vi7NAW__deviceImage",
  "root": "Device-module__vi7NAW__root",
  "stickyContainer": "Device-module__vi7NAW__stickyContainer",
  "text": "Device-module__vi7NAW__text",
});
